import { useQuery } from "react-query";
import { LoadingDots } from "web-ui";

import { getReleaseManagerData } from "api/dashboardBackend";
import { useSource } from "components/SourceContext";
import strings from "components/common/Common.strings.json";
import styles from "components/dashboard/release-managers/ReleaseManagers.module.scss";
import { type PlatformId } from "util/platform";

interface Props {
  platformId: PlatformId;
}

export const ReleaseManagersInfo = ({ platformId }: Props) => {
  const source = useSource();

  const params = new URLSearchParams();
  if (source !== null) {
    params.set("source", source);
  }
  const {
    data: data,
    isError: isError,
    isLoading: isLoading,
  } = useQuery({
    queryFn: () => getReleaseManagerData(platformId, params),
    queryKey: [platformId],
  });

  if (isError) {
    return <div>{strings.data_fetch_error}</div>;
  }

  if (!isError && !isLoading && !data) {
    return <div>{strings.no_data}</div>;
  }

  if (isLoading) {
    return <LoadingDots manualPositioning={true} type="screen-white" />;
  }

  return (
    <span className={styles.managers}>
      {data.managers.map(({ name, scheduleId }, j: number) => {
        if (scheduleId.length === 0) {
          return (
            <div className={styles.manager} key={`manager-${j}`}>
              {name}
            </div>
          );
        }

        return (
          <a
            className={styles.manager}
            href={`https://duolingo.pagerduty.com/schedules#${scheduleId}`}
            key={`manager-${j}`}
            rel="noopener noreferrer"
            target="_blank"
          >
            {name}
          </a>
        );
      })}
    </span>
  );
};

export default ReleaseManagersInfo;
